module.exports = __webpack_public_path__ + "img/future-house.9aace65c.jpg";